import { render, staticRenderFns } from "./numbChoose.vue?vue&type=template&id=0cf538e7&scoped=true"
import script from "./numbChoose.vue?vue&type=script&lang=js"
export * from "./numbChoose.vue?vue&type=script&lang=js"
import style0 from "@/v1-travel/assets/css/address.css?vue&type=style&index=0&id=0cf538e7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf538e7",
  null
  
)

export default component.exports